import { useState } from "react";
import { Button, Image, Tag } from "antd";
import ProfileContainer from "../components/ProfileContainer";

const MAX_LENGTH = 3;

const LEVELS = [
    {label: 'Entry', value: 1},
    {label: 'Mid-Tier', value: 5},
    {label: 'Top-Tier', value: 10}
];

const AgencyProfilePartnerPrograms = ({ items }) => {
    const [isOpen, setIsOpen] = useState(true);
    const keyServices = items// TB.sortBy(items, 'display_index');

    return (
        <div id="partnerships" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg pb-6">Partner Programs {!!keyServices.length && `(${keyServices.length})`}</h4>

                    {!keyServices.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Services Available</p>
                        </div>
                    )}

                    <div className="flex flex-col gap6 flex-wrap divide-y">
                        {keyServices?.slice(0, isOpen ? keyServices.length : MAX_LENGTH).map(program => {
                            return (
                                <ProfilePartnerRow
                                    key={program.id}
                                    program={program}
                                />
                            )
                        })}
                    </div>

                </div>
            </ProfileContainer>
        </div>
    )
}

export default AgencyProfilePartnerPrograms;


const ProfilePartnerRow = ({ program }) => {
    const [isDetailsOpen, setIsDetailsOpen] = useState(true);

    // console.log(JSON.stringify(program, null, 2))

    const startedAt = TB.moment(program.started_at)
    // const endedAt = TB.moment(program.ended_at)

    return (
        <div className="first:pt-0 bg-red100 p3 pt-8 mb-8 flex flex-col gap-4">

            <div className="flex flex-col gap-3">

                <div className="flex justify-between items-center">
                    <div>
                        <p className="text-xl">{program.name}</p>
                        <p className="text-gray-600 text-sm">{program.title} {program.level && ` (Level ${TB.find(LEVELS, ['value', program.level])?.label})`}</p>
                    </div>

                    {program?.marketplace_url && <div>
                        <a
                            href={program.marketplace_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-info text-sm fontmedium inline-flex items-center"
                        >
                            View Marketplace Profile
                            <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                            </svg>
                        </a>
                    </div>}

                    {/* {program.key_clients?.length && (
                        <p className="">{program.key_clients.length} clients</p>
                    )} */}
                </div>


                <div className="flex justify-between w-full items-center">
                    <div>
                        <p className="text-sm">Partner since {startedAt.format('MMMM D, YYYY')} </p>
                        {/* <div className="flex gap-2.5 pt-2">
                            <Tag color="purple">{program.vertical_focus}</Tag>
                            {program.total_certifications && (
                                <Tag color="geekblue">{program.total_certifications} Certs</Tag>
                            )}
                        </div> */}
                        <div className="flex gap-6 pt-3">
                            <p className="text-sm text-gray-600">Focus: {program.vertical_focus}</p>

                            {program.total_certifications && (
                                <p className="text-sm text-gray-600">Certifications: {program.total_certifications}</p>
                            )}
                        </div>

                        {/* <p className="font-bold pt-3">Program</p>
                        <p>{program.name}</p> */}
                    </div>

                    {/* <div className="bg-gray-50 p-2 rounded flex gap-5 justify-between">
                        <div>
                            <p className="text-xs font-bold">Started:</p>
                            <p className="text-xs">{startedAt.format('MMMM D, YYYY')}</p>
                        </div>
                        <div>
                            <p className="text-xs font-bold">Duration:</p>
                            <p className="text-xs">{endedAt.diff(startedAt, 'months')} months</p>
                        </div>
                        <div>
                            <p className="text-xs font-bold">Ended:</p>
                            <p className="text-xs">{endedAt.format('MMMM D, YYYY')}</p>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}